(() => {
  const initializeHeader = (header) => {
    if (header.dataset.initialized === 'true') return;
    header.dataset.initialized = 'true';

    const mega = header.querySelector('[data-mega-container]');
    const megaTriggers = Array.from(header.querySelectorAll('[data-mega-trigger]'));
    const megaPanels = Array.from(header.querySelectorAll('[data-mega-panel]'));
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileCart = header.querySelector('#cart-icon-bubble-mobile');
    const desktopCart = header.querySelector('#cart-icon-bubble');
    const mobilePanels = Array.from(header.querySelectorAll('[data-mobile-panel]'));
    let activeMega = null;
    let closeTimer = null;

    const setMega = (key) => {
      if (!mega) return;

      activeMega = key;
      const isOpen = key !== null;
      mega.classList.toggle('is-open', isOpen);

      megaTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === key));
      });

      megaPanels.forEach((panel) => {
        const isActive = panel.dataset.megaPanel === key;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    };

    const cancelClose = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const queueClose = () => {
      cancelClose();
      closeTimer = window.setTimeout(() => setMega(null), 150);
    };

    megaTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        cancelClose();
        setMega(trigger.dataset.megaTrigger);
      });
      trigger.addEventListener('focus', () => setMega(trigger.dataset.megaTrigger));
      trigger.addEventListener('click', () => {
        const key = trigger.dataset.megaTrigger;
        setMega(activeMega === key ? null : key);
      });
      trigger.closest('li')?.addEventListener('mouseleave', queueClose);
    });

    mega?.addEventListener('mouseenter', cancelClose);
    mega?.addEventListener('mouseleave', queueClose);
    mega?.querySelector('[data-mega-close]')?.addEventListener('click', () => setMega(null));

    const showMobilePanel = (key) => {
      mobilePanels.forEach((panel) => {
        const isCurrent = panel.dataset.mobilePanel === key;
        panel.classList.toggle('is-current', isCurrent);
        panel.setAttribute('aria-hidden', String(!isCurrent));
        if (isCurrent) panel.scrollTop = 0;
      });
    };

    const setMobileMenu = (isOpen) => {
      if (!mobileMenu || !mobileToggle) return;

      mobileMenu.classList.toggle('is-open', isOpen);
      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      mobileToggle.setAttribute(
        'aria-label',
        isOpen ? (window.theme?.strings?.close || 'Close menu') : (window.theme?.strings?.menu || 'Open menu')
      );
      document.body.classList.toggle('allbirds-menu-open', isOpen);

      if (isOpen) {
        setMega(null);
        showMobilePanel('root');
      }
    };

    mobileToggle?.addEventListener('click', () => {
      setMobileMenu(mobileToggle.getAttribute('aria-expanded') !== 'true');
    });

    const openCartDrawer = (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
      event.preventDefault();
      setMobileMenu(false);
      cartDrawer.open(mobileCart);
    };

    mobileCart?.addEventListener('click', openCartDrawer);
    mobileCart?.addEventListener('keydown', (event) => {
      if (event.code === 'Space') openCartDrawer(event);
    });

    if (mobileCart && desktopCart) {
      const syncMobileCart = () => {
        mobileCart.innerHTML = desktopCart.innerHTML;
      };
      new MutationObserver(syncMobileCart).observe(desktopCart, { childList: true, subtree: true });
    }

    header.querySelectorAll('[data-mobile-target]').forEach((button) => {
      button.addEventListener('click', () => showMobilePanel(button.dataset.mobileTarget));
    });

    header.querySelectorAll('[data-mobile-back]').forEach((button) => {
      button.addEventListener('click', () => showMobilePanel(button.dataset.mobileBack));
    });

    header.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      setMega(null);
      setMobileMenu(false);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) setMobileMenu(false);
      else setMega(null);
    });
  };

  const initializeFooter = (footer) => {
    if (footer.dataset.accordionsInitialized === 'true') return;
    footer.dataset.accordionsInitialized = 'true';

    const accordions = Array.from(footer.querySelectorAll('[data-footer-accordion]'));

    const syncPanels = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      accordions.forEach((item) => {
        const button = item.querySelector('[data-footer-accordion-button]');
        const panel = item.querySelector('[data-footer-accordion-panel]');
        if (!button || !panel) return;

        if (isDesktop) {
          panel.hidden = false;
          button.setAttribute('aria-expanded', 'true');
        } else {
          const expanded = item.classList.contains('is-open');
          panel.hidden = !expanded;
          button.setAttribute('aria-expanded', String(expanded));
        }
      });
    };

    accordions.forEach((item) => {
      const button = item.querySelector('[data-footer-accordion-button]');
      const panel = item.querySelector('[data-footer-accordion-panel]');
      if (!button || !panel) return;

      button.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        item.classList.toggle('is-open');
        const expanded = item.classList.contains('is-open');
        panel.hidden = !expanded;
        button.setAttribute('aria-expanded', String(expanded));
      });
    });

    syncPanels();
    window.addEventListener('resize', syncPanels);
  };

  const initialize = (container = document) => {
    container.querySelectorAll('[data-allbirds-header]').forEach(initializeHeader);
    container.querySelectorAll('[data-allbirds-footer]').forEach(initializeFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
